import { StyleSheet } from 'react-native';
import type { Theme } from '../../../src/theme/getTheme';

export const getMatchHubTeamFactNotesStyles = (theme: Theme) =>
  StyleSheet.create({
    note: {
      marginBottom: 12,
    },
    team: {
      fontSize: 12,
      fontWeight: '700',
      color: theme.primary,
      marginBottom: 2,
    },
    fact: {
      fontSize: 13,
      lineHeight: 19,
      color: theme.gray[700],
    },
  });
